import {logger} from 'tizra'

const log = logger('ssoLogin')

export const ssoLogin = (authAgent: 'sso' | 'custom') => {
  if (authAgent === 'sso') {
    window.location.assign('/api/sso-redirect')
    return
  }
  const {customLoginUrl} = window.tizra
  if (
    log.assert(customLoginUrl, 'authAgent=tizra but customLoginUrl is not set')
  ) {
    window.location.assign(customLoginUrl!)
  }
}
